import React from "react";
import { chipStyle, chipWrapperStyle, emptyTextStyle } from "./GuideDetailModal.styles";

export function formatDate(value?: string | null) {
    if (!value) return "Not provided";
    const dt = new Date(value);
    return dt.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function formatDateTime(value?: string | null) {
    if (!value) return "Not provided";
    const dt = new Date(value);
    return dt.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

export function formatBoolean(value?: boolean | null) {
    if (value === null || value === undefined) return "Not provided";
    return value ? "Yes" : "No";
}

export function formatCurrency(value?: number | null) {
    if (value === null || value === undefined || Number.isNaN(value)) return "--";
    return `$${value.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    })}`;
}

export function ChipList({ values, empty = "Not provided" }: { values?: string[] | null; empty?: string }) {
    if (!values || values.length === 0) {
        return <div style={emptyTextStyle}>{empty}</div>;
    }

    return (
        <div style={chipWrapperStyle}>
            {values.map((value, index) => (
                <span key={`${value}-${index}`} style={chipStyle}>
                    {value}
                </span>
            ))}
        </div>
    );
}
